import { globalMeegoExternals } from './common';

export const externalGetterMap: {
  [externalModuleName: string]: [getters: () => Promise<unknown>, dependencies?: string[]];
} = {};

export const registerExternalGetter = (
  moduleName: string,
  getter: () => Promise<unknown>,
  dependencies?: string[],
) => {
  if (externalGetterMap[moduleName]) {
    console.warn(`[EB] Overriding external getter for ${moduleName}`);
  }
  externalGetterMap[moduleName] = [getter, dependencies];
};

const pendingPrepareExternalMap: Record<string, Promise<unknown> | undefined> = {};

/**
 * 基于 externalGetterMap 中的注册的配置，初始化 externals
 * 如果声明了有依赖，那么先会把依赖部分初始化，递归进行
 *
 * TODO：处理一下循环依赖
 *
 * @param externalName
 */
export const prepareExternal = async (externalName: string) => {
  if (globalMeegoExternals[externalName]) {
    return globalMeegoExternals[externalName];
  }

  if (externalGetterMap[externalName]) {
    if (pendingPrepareExternalMap[externalName]) {
      return pendingPrepareExternalMap[externalName];
    }

    pendingPrepareExternalMap[externalName] = new Promise(async resolve => {
      const [getter, dependencies] = externalGetterMap[externalName];

      if (dependencies && dependencies.length) {
        await Promise.all(
          dependencies.filter(dep => !globalMeegoExternals[dep]).map(e => prepareExternal(e)),
        );
      }
      resolve(
        getter().then(module => {
          globalMeegoExternals[externalName] = module;
        }),
      );
    });

    return pendingPrepareExternalMap[externalName];
  }
  throw new Error(`[EB] ${externalName} has no external getter config`);
};

export const ensureExternalsPrepared = (externals: string[] = []) => {
  return Promise.all(
    externals
      .filter(externalName => !globalMeegoExternals[externalName])
      .map(externalName => prepareExternal(externalName)),
  );
};
